import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = {
  "clip-rule": "evenodd",
  "fill-rule": "evenodd",
  "image-rendering": "optimizeQuality",
  "shape-rendering": "geometricPrecision",
  "text-rendering": "geometricPrecision",
  viewBox: "0 0 1024 1024",
  width: "48px",
  height: "48px",
  xmlns: "http://www.w3.org/2000/svg"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createStaticVNode("<g id=\"ec-c11e22e0-73d4-4a9e-8e15-29ef76a96e7e-__图层_x0020_1\" transform=\"matrix(403.149597, 0, 0, 403.149597, 0.000019, 0.000019)\"><circle cx=\"1.27\" cy=\"1.27\" fill=\"#48b02c\" r=\"1.27\"></circle><g fill=\"#fff\"><path d=\"m1.143 1.94404v-1.27002c0-.06994.05705-.12699.12699-.12699h.00002c.06994 0 .12699.05705.12699.12699v1.27002c0 .06994-.05705.12699-.12699.12699h-.00002c-.06994 0-.12699-.05705-.12699-.12699z\"></path><path d=\"m.63499 1.18203h1.27002c.06994 0 .12699.05705.12699.12699v.00002c0 .06994-.05705.12699-.12699.12699h-1.27002c-.06994 0-.12699-.05705-.12699-.12699v-.00002c0-.06994.05705-.12699.12699-.12699z\"></path></g></g>", 1)
  ]))]))
}
export default { render: render }